import { createSlice } from "@reduxjs/toolkit";
import appApi from "../api";

type Office = {
  id: string;
  name: string;
  dailyPrice: string;
  weeklyPrice: string;
  monthlyPrice: string;
  description: string;
  type: string;
  images?: string[]; 
};

type OfficeState = {
  offices: Office[];
  loading: boolean;
  error: string | null;
};
const initialState: OfficeState = {
  offices: [],
  loading: false,
  error: null,
};
const officeSlice = createSlice({
  name: "office",
  initialState,
  reducers: {
    setOffices: (state, action) => {
      state.offices = action.payload;
    },
    addOffice: (state, action) => {
      state.offices.push(action.payload);
    },
    updateOffice: (state, action) => {
      const index = state.offices.findIndex(
        (office) => office.id === action.payload.id
      );
      if (index !== -1) {
        state.offices[index] = action.payload;
      }
    }
    ,
    deleteOffice: (state, action) => {
      state.offices = state.offices.filter(
        (office) => office.id !== action.payload
      );
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        appApi.endpoints.fetchOffices.matchFulfilled,
        (state, action) => {
          state.offices = action.payload;
          state.loading = false;
          state.error = null;
        }
      )
    }
});
export const { setOffices, addOffice, updateOffice, deleteOffice } = officeSlice.actions;
export default officeSlice.reducer;
export const getOffices = (state: { office: OfficeState }) => state.office.offices;
export const selectLoading = (state: { office: OfficeState }) => state.office.loading;
